import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboards/machines',
        loadChildren: () => import('./main/dashboards/routes').then((m) => m.routes),
      },
      {
        path: 'orders',
        loadChildren: () => import('./main/orders/routes').then((m) => m.routes),
      },
      {
        path: 'punching',
        loadChildren: () => import('./main/punch-pattern/routes').then((m) => m.routes),
      },
      {
        path: 'inventory',
        loadChildren: () => import('./main/inventory/routes').then((m) => m.routes),
      },
      {
        path: 'warehouse',
        loadChildren: () => import('./main/warehouse/routes').then((m) => m.routes),
      },
      {
        path: 'report',
        loadChildren: () => import('./main/reports/routes').then((m) => m.routes),
      },
      {
        path: 'production-explorer',
        loadChildren: () => import('./main/explorer/routes').then((m) => m.routes),
      },
      {
        path: 'machines',
        loadChildren: () => import('./main/machines/routes').then((m) => m.routes),
      },
      {
        path: 'tooling',
        loadChildren: () => import('./main/tooling/routes').then((m) => m.routes),
      },
      {
        path: 'settings',
        loadChildren: () => import('./main/settings/routes').then((m) => m.routes),
      },
      {
        path: 'schedule',
        loadChildren: () => import('./main/schedule/routes').then((m) => m.routes),
      },
      { path: '', redirectTo: 'dashboards/machines', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboards/machines' },
    ],
  },
];
